import { useEffect, useState } from "react"
import type { SuccessFetch } from "../../../../../../../../types"
import { useApi } from "../../../../../../../../utils"

interface SelectOptionType {
  label: string
  value: string
  code: string
}

export function useEmployeeStatus() {
  const api = useApi()
  const [data, setData] = useState<SelectOptionType[]>([])
  const [isLoading, setLoading] = useState(false)

  const refetch = () => {
    setLoading(true)

    api.get("/employeestatus/")
    .then((res: SuccessFetch<{
      payload: {
        employee_status_id: number
        employee_status_name: string
        employee_status_code: string
      }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.employee_status_name, value: item.employee_status_id.toString(), code: item.employee_status_code }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
  }

  useEffect(() => {
    setLoading(true)

    api.get("/employeestatus/")
    .then((res: SuccessFetch<{
      payload: {
        employee_status_id: number
        employee_status_name: string
        employee_status_code: string
      }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.employee_status_name, value: item.employee_status_id.toString(), code: item.employee_status_code }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
    // eslint-disable-next-line
  }, [])

  return { data, isLoading, refetch }
}